import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const globalResultDataClassName = DataClassName.GLOBAL_RESULT
const globalResultEndpoint = PisaDataClassEndpoint.GLOBAL_RESULT

export function pisaGlobalResultDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(globalResultDataClassName, {
    title: globalResultDataClassName,
    restApi: createPisaRestApiConfig(globalResultEndpoint),
    attributes,
  })
}
